import { render, staticRenderFns } from "./JdsButton.vue?vue&type=template&id=7d91ec19"
import script from "./JdsButton.vue?vue&type=script&lang=js"
export * from "./JdsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports